module.exports = __webpack_public_path__ + "static/media/bg_2.4023b9f9.jpg";